
import { Button, Checkbox, Modal, Picker } from "antd-mobile";
import Cookies from "js-cookie";
import { useState } from "react";
export default function LiveToggle() {


    const [isLive, setIsLive] = useState((Cookies.get("l") === "true") || false);

    const [visible, setVisible] = useState(false);

    // Don't show toggle in production
    let mode = process.env.REACT_APP_API || 'inherit';
    if (mode === "live" || mode === "staging") {
        return (<></>);
    }


    const options = [
        { label: "unset", value: "" },
        { label: "tbraun", value: "https://tbraunapi.bookmanager.com/" },
        { label: "eric", value: "https://ericapi.bookmanager.com/" },
        { label: "atoth", value: "https://atothapi.bookmanager.com/" },
        { label: "mike", value: "https://mikeapi.bookmanager.com/" },
        { label: "dev", value: "https://devapi.bookmanager.com/" },
        { label: "staging", value: "https://stagingapi.bookmanager.com/" },
        { label: "live", value: "https://api.bookmanager.com/" },
    ]



    let _style = {
        boxShadow: "0px 2px 3px 1px #333",
        width: "30px",
        position: "fixed",
        zIndex: "1000",
        top: "-1px",
        left: "20px",

        borderBottomLeftRadius: "3px",
        borderBottomRightRadius: "3px",
        cursor: "pointer",
        margin: "0 auto"
    }


    return (
        <div style={_style} >
            <div className="shim" />
            <Picker
                columns={[options]}
                title = {Cookies.get("api") || "Not set"}
                visible={visible}
                onClose={() => setVisible(false)}
                onConfirm={(item, e) => {
                    Modal.confirm({
                        title: "Set database",
                        confirmText: "Use Live",
                        cancelText: "Use Dev",
                        onConfirm: () => {
                            Cookies.set("l", "true")
                            Cookies.set("api", item);
                            setIsLive(true);
                            window.location.reload();
                        },
                        onCancel: () => {
                            Cookies.set("l", "false")
                            Cookies.set("api", item);
                            setIsLive(false);
                            window.location.reload();
                        }
                    })
                }}
                confirmText={"Select"} // Hides the confirm button
                cancelText={"Cancel"}  // Hides the cancel button
            />

            <Button onClick={() => setVisible(true)} size="small" style={{ "border": "none", "color": (isLive) ? "#34c934" : "gray" }}>&bull;</Button>
        </div>
    )
}